import { render, staticRenderFns } from "./FormInstallationSpecs.vue?vue&type=template&id=22ad790a&"
import script from "./FormInstallationSpecs.vue?vue&type=script&lang=js&"
export * from "./FormInstallationSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports